<button
  b2cElement
  modalType="unselect"
  type="button"
  data-cy="unselect_btn"
  class="unselect-button"
  [title]="config().title"
  [attr.aria-label]="config().title"
  [style.color]="config().color"
  [style.fontFamily]="config().fontFamily"
  (click)="
    displayUnselectDialog(
      phase(),
      challenge(),
      isBisCampaign(),
      isEventChallenge()
    )
  "
>
  {{ config().text }}
</button>
